import { FC } from 'react'

import styles from './MessageManager.module.scss'
import { format, parse } from 'date-fns'
import { IMessage, IMessageSocket } from '@/shared/services/types/chat.types'
import clsx from 'clsx'
import { utcToZonedTime } from 'date-fns-tz'

interface IProps {
	data: IMessageSocket
	isUser?: boolean
}

export const MessageManager: FC<IProps> = ({ data, isUser }) => {
	const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
	//2023-11-21T19:29:30
	//2023-11-20 11:48:30
	const [normData] = data.create_date.split('.')

	const parsedDate = parse(normData, 'yyyy-MM-dd HH:mm:ss', new Date())

	const year = parsedDate.getFullYear()
	const month = parsedDate.getMonth()
	const day = parsedDate.getDate()
	const hours = parsedDate.getHours()
	const minutes = parsedDate.getMinutes()

	const newDate = new Date(Date.UTC(year, month, day, hours, minutes))

	const zonedDate = utcToZonedTime(newDate, timeZone)

	const time = format(zonedDate, 'HH:mm')

	return (
		<div className={clsx(styles.wrapper, isUser && styles.wrapperUser)}>
			<div className={styles.message}>
				<div
					className={styles.text}
					dangerouslySetInnerHTML={{ __html: data.message }}
				/>
				<div className={styles.triangle} />
			</div>

			<div className={styles.avatarBlock}>
				<div className={styles.avatar}>
					<svg
						width='32'
						height='32'
						viewBox='0 0 32 32'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
					>
						<circle cx='16' cy='16' r='16' fill='#F4F4F9' />
						<path
							d='M16.0147 9.7627C14.388 9.7627 13.0547 11.096 13.0547 12.7227C13.0547 14.3494 14.388 15.6827 16.0147 15.6827C17.6414 15.6827 18.9747 14.3494 18.9747 12.7227C18.9747 11.0961 17.6414 9.7627 16.0147 9.7627Z'
							fill='#695CB8'
						/>
						<path
							d='M20.4147 17.2824C19.6414 16.5091 18.548 16.0557 17.4015 16.0557L14.628 16.0558C13.4813 16.0558 12.388 16.5091 11.6147 17.2825C10.4147 18.4825 9.74805 20.0825 9.74805 21.7892C9.74805 22.0825 9.98805 22.3225 10.2813 22.3225H21.7746C22.0679 22.3225 22.3079 22.0825 22.3079 21.7892C22.2814 20.0558 21.6147 18.4557 20.4147 17.2825L20.4147 17.2824Z'
							fill='#695CB8'
						/>
					</svg>
				</div>
				<span className={styles.date}>{time}</span>
			</div>
		</div>
	)
}
